import React, { createElement, useEffect, useRef } from "react";
import { hydrateMarketingRichText } from "Utils/richTextS3ImageUtil";

const RichTextContent: React.FC<any> = ({
  as = "div",
  html = "",
  ...props
}) => {
  const ref = useRef<HTMLElement | null>(null);

  useEffect(() => {
    hydrateMarketingRichText(ref.current);
  }, [html]);

  return createElement(as, {
    ...props,
    ref,
    dangerouslySetInnerHTML: { __html: html || "" },
  });
};

export default RichTextContent;
